@use '@lib/assets/styles/main.scss' as *;

.value {
  color: $gray0;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 153.846% */
  letter-spacing: -0.013px;
}
